<template>

  <modal name="createProjectModal" @closed="hideModal" tabindex="-1" aria-hidden="true" height="144.19" width="700">
    <div class="p-4">
    <button @click="hideModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">
          &times;
        </span>
    </button>
    <input
      @keyup.enter="createProject"
      ref="createProjectInput"
      spellcheck="false"
      :placeholder="$t('modals.create_project_modal.set_new_project_name')"
      class="form-control form-control-flush form-control-sm"
      style="font-size: 1.4rem; resize: none; text-shadow: 0 0.5px gainsboro;"
      v-model="new_project.name"
    >
    <button v-on:click="createProject" type="button" class="btn btn-sm btn-primary float-right"><i
      class="fe fe-check-circle"></i>{{ $t('modals.create_project_modal.create_project') }}
    </button>
    </div>
  </modal>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'create_project',
    data () {
      return {
        drag: false,
        new_project: {
          name: '',
        },
      };
    },
    computed: {
      ...mapGetters([
        'dragOptions',
        'members',
        'show_modal_create_project',
      ]),
    },
    watch: {
      show_modal_create_project: function () {
        if (this.show_modal_create_project === true) {
          this.$modal.show('createProjectModal');
          setTimeout(() => this.$refs.createProjectInput.focus(), 850);
        }
      },

    },

    methods: {
      getMember (memberId) {
        return this.members.find(m => m._id === memberId, 1) || {};
      },
      createProject () {
        this.$store.dispatch('createProject', this.new_project);
        setTimeout(() => this.$store.commit('showModal', 'edit_project'), 800);
        this.new_project.name = '';

        this.$modal.hide('createProjectModal');
      },
      hideModal () {
        this.$store.commit('hideModal', 'create_project');
        this.$modal.hide('createProjectModal');
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  html, body {
    width: 100%;
    height: 100%;
  }

</style>
